import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { useRouter } from '../../hooks/use_router';
import { RoutePaths, WaterbodyPaths } from '../../routes';

interface WaterbodySeoPagesNavProps {
  urlSlug: string;
  has_survey_chart_data: boolean;
}

export const WaterbodySeoPagesNav = (props: WaterbodySeoPagesNavProps) => {
  const { urlSlug, has_survey_chart_data } = props;

  const { pathname } = useRouter();

  const routes = [
    {
      url: `${RoutePaths.WATERS}/${urlSlug}${WaterbodyPaths.FISHING_REPORTS}`,
      label: 'Fishing Reports',
    },
    {
      url: `${RoutePaths.WATERS}/${urlSlug}${WaterbodyPaths.FISHING_PATTERNS}`,
      label: 'Fishing Patterns',
    },
    has_survey_chart_data
      ? {
          url: `${RoutePaths.WATERS}/${urlSlug}${WaterbodyPaths.SPECIES}`,
          label: 'Fish Species',
        }
      : null,
    {
      url: `${RoutePaths.WATERS}/${urlSlug}${WaterbodyPaths.BOAT_RAMPS}`,
      label: 'Boat Ramps',
    },
  ].filter(Boolean);

  return (
    <nav className="flex">
      <ul className="flex p-1 bg-[#e0e4e3] rounded">
        {routes.map((route, index) => {
          const isActive = pathname.startsWith(route.url);
          return (
            <li key={index}>
              <Link
                to={route.url}
                className={classNames('block px-4 py-1.5 text-center', {
                  'bg-white font-bold shadow rounded-sm': isActive,
                })}
              >
                {route.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
